<template>
  <div class="pdf-hidden-sections-container">
    <div
      v-for="section in sections"
      :key="section.name"
      :class="[ section.class, { 'section--disabled': section.disabled, 'section--not-disableable': !section.isDisableable } ]"
      class="section"
      @click="handleSectionClick(section)"
    >
      <q-tooltip :offset="[4, 4]">
        {{ section.tooltip }}
      </q-tooltip>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        sections: [
          { value: 'header', class: 'header', tooltip: this.$t('pdf_hidden_sections_header'), disabled: false, isDisableable: true },
          { value: 'address-box.return', class: 'address-box-return', tooltip: this.$t('pdf_hidden_sections_return_address'), disabled: false, isDisableable: true },
          { value: 'address-box.address', class: 'address-box-address', tooltip: this.$t('pdf_hidden_sections_address'), disabled: false, isDisableable: false },
          { value: 'invoice-meta', class: 'invoice-meta', tooltip: this.$t('pdf_hidden_sections_invoice_meta'), disabled: false, isDisableable: false },
          { value: 'content', class: 'content', tooltip: this.$t('pdf_hidden_sections_content'), disabled: false, isDisableable: false },
          { value: 'footer', class: 'footer', tooltip: this.$t('pdf_hidden_sections_footer'), disabled: false, isDisableable: true }
        ]
      }
    },

    props: {
      value: {
        required: true,
        type: Array
      }
    },

    methods: {
      handleSectionClick (section) {
        if (!section.isDisableable) {
          return
        }

        section.disabled = !section.disabled
      },

      applyValues (values) {
        values.forEach(val => {
          const section = this.sections.find(section => section.value === val)
          section.disabled = true
        })
      }
    },

    watch: {
      sections: {
        handler: function () {
          const data = this.sections.filter(section => section.disabled).map(section => section.value)
          this.$emit('input', data)
        },
        deep: true
      },

      value (newVal) {
        this.applyValues(newVal)
      }
    },

    created () {
      this.applyValues(this.value)
    }
  }
</script>

<style lang="stylus">
  @import '~variables'

  .pdf-hidden-sections-container
    height: 250px
    width: 200px
    display: grid
    grid-template-columns: 25% 25% 25% 25%
    grid-template-rows: 40px 10px 20px 30px 1fr 40px
    grid-template-areas:
      "header header header header"\
      "address-box-return address-box-return . ."\
      "address-box-address address-box-address . ."\
      "invoice-meta invoice-meta . ."\
      "content content content content"\
      "footer footer footer footer"
    row-gap: 5px

    .section
      background: $grey-6
      height: 100%
      cursor: pointer
      &--disabled
        background: $grey-4
      &--not-disableable
        cursor: not-allowed

      &.header
        grid-area: header

      &.address-box-return
        grid-area: address-box-return

      &.address-box-address
        grid-area: address-box-address

      &.invoice-meta
        grid-area: invoice-meta

      &.content
        grid-area: content

      &.footer
        grid-area: footer
</style>
